// extracted by mini-css-extract-plugin
export var chevron = "_bw-4";
export var chevronExpanded = "_bw-5";
export var row = "_bw-0";
export var rowBody = "_bw-6";
export var rowDescription = "_bw-7";
export var rowHeader = "_bw-1";
export var rowTitle = "_bw-2";
export var rowTitleComplete = "_bw-3";